/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAdvisorBookingDetailModel } from '../../models/medical-advisor-booking-detail-model';

export interface MedicalAdvisorConfirmBookingPost$Params {
      body?: MedicalAdvisorBookingDetailModel
}

export function medicalAdvisorConfirmBookingPost(http: HttpClient, rootUrl: string, params?: MedicalAdvisorConfirmBookingPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, medicalAdvisorConfirmBookingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<string>;
    })
  );
}

medicalAdvisorConfirmBookingPost.PATH = '/MedicalAdvisor/ConfirmBooking';
